<!-- <div class="container-wrap">
    <app-progress-bar class="progress-bar-top-fixed" mode="indeterminate"></app-progress-bar>
    <div class="container">
        <mat-slide-toggle class="top-right-toggle" [checked]="themeChecked" (change)="themeToggle($event)"
            #darkModeSwitch></mat-slide-toggle>
        <div class="center-form-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div> -->
<div class="container-wrap">
    <app-progress-bar class="progress-bar-top-fixed" mode="indeterminate"></app-progress-bar>
    <!-- <mat-sidenav-container class="sidenav-container"> -->
    <div class="container">
        <mat-slide-toggle class="top-right-toggle" [checked]="themeChecked" (change)="themeToggle($event)"
            #darkModeSwitch></mat-slide-toggle>
        <div class="center-form-container">
            <mat-card class="p-3">
                <router-outlet></router-outlet>
            </mat-card>
        </div>
    </div>
    <!-- </mat-sidenav-container> -->
</div>
<!-- <div class="container-wrap">
    <app-progress-bar class="progress-bar-top-fixed" mode="indeterminate"></app-progress-bar>
    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #sidenav class="sidenav">
            <div class="sidebar-main scrollbar-none">
                <app-sidenav></app-sidenav>
            </div>
        </mat-sidenav>
        <mat-sidenav-content>
            
            <div class="main-content">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div> -->